<script>
    import { format } from "svelte-i18n";
    import { onMount } from "svelte";
    import * as bootstrap from "bootstrap";

    let { columnsDefinition = [], list = "" } = $props();
    let columns = $derived(columnsDefinition.filter((col) => col.key !== "select"));

    let modalElement;
    let myModalInstance;

    onMount(() => {
        myModalInstance = new bootstrap.Modal(modalElement);
    });

    const openModal = (e) => {
        e.preventDefault();
        myModalInstance.show();
    };

    // Explicit close function bound to the X button
    const closeModal = () => {
        myModalInstance.hide();
    };
</script>

<!-- THE TRIGGER -->
<a href="#" onclick={openModal} class="no-export">
    {$format(`list.columns.ref.title`)}
    <i class="far fa-question-circle"></i>
</a>

<!-- THE MODAL -->
<div
    class="modal fade"
    tabindex="-1"
    aria-hidden="true"
    bind:this={modalElement}
>
    <div class="modal-dialog modal-xl">
        <div class="modal-content">
            <div class="modal-header">
                <!-- FIX: Swapped data-bs-dismiss for native Svelte onclick -->
                <button
                    type="button"
                    class="btn-close"
                    onclick={closeModal}
                    aria-label="Close"
                ></button>
            </div>
            <div class="modal-body reference-container d-flex flex-wrap">
                {#each columns as col (col.key)}
                    <div class="mt-3 reference-item">
                        {#if col.key == "rels"}
                            {@html $format(`list.columns.ref.${list}.${col.key}`, {values: {kind: col.title}})}
                        {:else}
                            {@html $format(`list.columns.ref.${list}.${col.key}`)}
                        {/if}
                    </div>
                {/each}
            </div>
        </div>
    </div>
</div>

<style>
    .reference-container {
        gap: 16px;
        padding: 3em;
    }
    .reference-item {
        border-bottom: 1px solid #ccc;
        padding: 16px 5px;
        flex: 1 1 300px;
        margin: 0 16px;
        max-width: 300px;
    }
</style>